import { useCalendarDatepicker } from 'shared/lib/selectCalendar';
import { DateValueContainer } from './styles';
import { Typography } from 'shared/ui/typography';

export const SelectDateValue = () => {
	const { dateString, isDisabled } =
		useCalendarDatepicker();
	return (
		<DateValueContainer>
			<Typography colorVariant={isDisabled ? 'neutral' : 'default'}>
				{dateString}
			</Typography>
		</DateValueContainer>
	);
};
